import { Translate } from "components/common/Translate/Translate";
import { useMemeEditor } from "../MemeEditorContext";
import { Buttons } from "./Buttons/Buttons";
import { MemesList } from "./MemesList/MemesList";
import { Padding } from "./Padding/Padding";

export const LeftBar = () => {
    const { isEditPage } = useMemeEditor();
    return (
        <div className="flex flex-col h-full max-h-full pb-6 overflow-y-auto scroll">
            {!isEditPage ? (
                <div className="flex flex-col gap-2 p-6">
                    <h1 className="text-2xl font-semibold">
                        <Translate keyName="meme-generator" />
                    </h1>
                </div>
            ) : (
                <div className="py-1"></div>
            )}
            <MemesList />
            <Buttons />
            <Padding />
        </div>
    );
};
